import { ReactComponent as EmailTextIcon } from "../../../assets/images/icons/EmailTextIcon.svg";
import { ReactComponent as HyperlinkIcon } from "../../../assets/images/icons/HyperlinkIcon.svg";
import { ReactComponent as SortTextIcon } from "../../../assets/images/icons/SortTextIcon.svg";
import { ReactComponent as LongTextIcon } from "../../../assets/images/icons/LongText.svg";
import { ReactComponent as URLIcon } from "../../../assets/images/icons/UrlIcon.svg";
import { ReactComponent as DateTimeIcon } from "../../../assets/images/icons/DatendTime.svg";
import { ReactComponent as PersonnIcon } from "../../../assets/images/icons/person.svg";
import { ReactComponent as DateIcon } from "../../../assets/images/icons/date.svg";
import { ReactComponent as NumberIcon } from "../../../assets/images/icons/number.svg";
import { ReactComponent as DollarIcon } from "../../../assets/images/icons/DollarIcon.svg";
import { ReactComponent as Percentage } from "../../../assets/images/icons/Percentage.svg";
import { ReactComponent as CheckMark } from "../../../assets/images/icons/CheckMark.svg";

export const INITIAL_INPUTS = [
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    inputType: "email",
    inputName: "Email",
    baseInputType: "text",
    svg: EmailTextIcon,
  },
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    inputType: "shortText",
    baseInputType: "text",
    inputName: "Short Text",
    svg: SortTextIcon,
  },
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    inputType: "longText",
    baseInputType: "text",
    inputName: "Long Text",
    svg: LongTextIcon,
  },
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    inputType: "hyperlink",
    inputName: "Hyperlink",
    baseInputType: "text",
    svg: HyperlinkIcon,
  },
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    baseInputType: "text",
    inputType: "url",
    inputName: "URL",
    svg: URLIcon,
  },
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    inputType: "number",
    inputName: "Number",
    baseInputType: "number",
    svg: NumberIcon,
  },
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    inputType: "currency",
    inputName: "Currency",
    baseInputType: "number",
    svg: DollarIcon,
  },
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    inputType: "percentage",
    inputName: "Percentage",
    baseInputType: "number",
    svg: Percentage,
  },
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    baseInputType: "date",
    inputType: "date",
    inputName: "Date",
    svg: DateIcon,
  },
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    inputType: "datetime",
    inputName: "Date & Time",
    baseInputType: "date",
    svg: DateTimeIcon,
  },
  {
    inputId: "",
    inputValue: "",
    inputDescription: "",
    baseInputType: "dropdown",
    inputType: "choice",
    inputName: `Choice`,
    svg: CheckMark,
  },
  // {
  //   inputId: "",
  //   inputValue: "",
  //   inputDescription: "",
  //   inputType: "person",
  //   inputName: "Person",
  //   baseInputType: "person",
  //   svg: PersonnIcon,
  // },
];
